import React from 'react';
import { ModalOverlay } from '../BlockScreen';
import { CloseIcon } from '../Icons';
import './index.css'


interface SideMenuProps {
  children?: React.ReactNode;
  openMenu?: boolean;
  handleCloseSideMenu: () => void;
  title?: string
}

const SideMenu: React.FC<SideMenuProps> = ({ children, openMenu = false, title = "", handleCloseSideMenu }) => {

  return (
    <React.Fragment>
      <ModalOverlay show={openMenu} onClose={() => handleCloseSideMenu()} />
      <div className={`sidemenu-section ${openMenu ? 'show' : ''}`}>
        <div className='sidemenu-content'>
          <div className='sidemenu-title'>
            <span>{title}</span>
            <CloseIcon className='sidemenu-close-icon' onClick={() => handleCloseSideMenu()} />
          </div>

          <div className='sidemenu-children'>
            {children}
          </div>


        </div>
      </div>
    </React.Fragment>
  );
}

export default SideMenu;
